import useFetch from "../../hooks/useFetch";
import InitialLoad from "../../components/initial-load/initial-load.component";
import LoadingIndicator from "../../components/loading-indicator/loading-indicator.component";
import ContactCTA from "../../components/contact-cta/contact-cta.component";
import Hero from "../../components/hero/hero.component";
import FeaturedTitle from "../../components/featured-title/featured-title.component";
import LeadershipTeam from "../../components/leadership-team/leadership-team.component";
import SiteHeader from "../../components/site-header/site-header.component";

import "./people.styles.scss";

const People = () => {
  const url = `${process.env.REACT_APP_API_BASE}/api/people`;
  const { loading, error, data } = useFetch(`${url}?populate=*`);

  if (loading) return <LoadingIndicator loading={true} />;
  if (error) {
    console.log(error);
    return (
      <section className="error">
        <p>Error ⛔.</p>
      </section>
    );
  }

  if (data.data.attributes) {
    const hero = data.data.attributes.Hero;
    const featuredTitle = data.data.attributes.FeaturedTitle;
    const team = data.data.attributes.LeadershipTeam;
    const contactCTA = data.data.attributes.ContactCta;

    return (
      <section className="people">
        <InitialLoad />
        <SiteHeader />
        <Hero title={hero.PageTitle} useVideo={hero.UseVideo} apiUrl={url} />
        <FeaturedTitle
          title={featuredTitle.Title}
          desc={featuredTitle.OptionalDescription}
          useDecodeEffect={
            featuredTitle.UseDecodeEffect !== null
              ? featuredTitle.UseDecodeEffect
              : false
          }
        />
        <LeadershipTeam title={team.Title} apiUrl={url} />
        <ContactCTA
          title={contactCTA.Title}
          link={contactCTA.LinkDestination}
          linkText={contactCTA.LinkText}
          useParallaxEffect={
            contactCTA.UseParallaxEffect !== null
              ? contactCTA.UseParallaxEffect
              : false
          }
          apiUrl={url}
        />
      </section>
    );
  } else {
    return <div>Data not returned</div>;
  }
};

export default People;
